import * as React from 'react';

import type { IconProps } from './types';

export const ListBullet = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M4.72214 7.06831C5.4892 7.06831 6.11103 6.44648 6.11103 5.67942C6.11103 4.91235 5.4892 4.29053 4.72214 4.29053C3.95508 4.29053 3.33325 4.91235 3.33325 5.67942C3.33325 6.44648 3.95508 7.06831 4.72214 7.06831Z"
        fill={color}
      />
      <path
        d="M8.05556 6.23611H16.1111C16.2585 6.23611 16.3998 6.17758 16.5039 6.07339C16.6081 5.96921 16.6667 5.8279 16.6667 5.68056C16.6667 5.53321 16.6081 5.39191 16.5039 5.28772C16.3998 5.18353 16.2585 5.125 16.1111 5.125H8.05556C7.90821 5.125 7.76691 5.18353 7.66272 5.28772C7.55853 5.39191 7.5 5.53321 7.5 5.68056C7.5 5.8279 7.55853 5.96921 7.66272 6.07339C7.76691 6.17758 7.90821 6.23611 8.05556 6.23611Z"
        fill={color}
      />
      <path
        d="M4.72214 11.5126C5.4892 11.5126 6.11103 10.8908 6.11103 10.1238C6.11103 9.35669 5.4892 8.73486 4.72214 8.73486C3.95508 8.73486 3.33325 9.35669 3.33325 10.1238C3.33325 10.8908 3.95508 11.5126 4.72214 11.5126Z"
        fill={color}
      />
      <path
        d="M16.1111 9.56934H8.05556C7.90821 9.56934 7.76691 9.62787 7.66272 9.73205C7.55853 9.83624 7.5 9.97755 7.5 10.1249C7.5 10.2722 7.55853 10.4135 7.66272 10.5177C7.76691 10.6219 7.90821 10.6804 8.05556 10.6804H16.1111C16.2585 10.6804 16.3998 10.6219 16.5039 10.5177C16.6081 10.4135 16.6667 10.2722 16.6667 10.1249C16.6667 9.97755 16.6081 9.83624 16.5039 9.73205C16.3998 9.62787 16.2585 9.56934 16.1111 9.56934Z"
        fill={color}
      />
      <path
        d="M4.72214 15.9572C5.4892 15.9572 6.11103 15.3354 6.11103 14.5683C6.11103 13.8013 5.4892 13.1794 4.72214 13.1794C3.95508 13.1794 3.33325 13.8013 3.33325 14.5683C3.33325 15.3354 3.95508 15.9572 4.72214 15.9572Z"
        fill={color}
      />
      <path
        d="M16.1111 14.0139H8.05556C7.90821 14.0139 7.76691 14.0724 7.66272 14.1766C7.55853 14.2808 7.5 14.4221 7.5 14.5695C7.5 14.7168 7.55853 14.8581 7.66272 14.9623C7.76691 15.0665 7.90821 15.125 8.05556 15.125H16.1111C16.2585 15.125 16.3998 15.0665 16.5039 14.9623C16.6081 14.8581 16.6667 14.7168 16.6667 14.5695C16.6667 14.4221 16.6081 14.2808 16.5039 14.1766C16.3998 14.0724 16.2585 14.0139 16.1111 14.0139Z"
        fill={color}
      />
    </svg>
  )
);

export default ListBullet;
